import * as React from 'react';
import { Table, Card, Spinner } from 'react-bootstrap'; 
import * as models from '../../models';
import dateFormat from 'dateformat';
import addIcon from '../../assets/images/Blue/add.svg';
import refreshIcon from '../../assets/images/icons8-refresh.svg';
import SingleActionButton from '../common/SingleActionButton';
import CommentModal from './CommentModal'; 
import { CardBody } from 'reactstrap';
import { userHasPermission } from '../../utils/helpers';
import { AiReportViewerModal } from '../ai-lab/AiReportViewerModal';

interface Props {
    isLoading?: boolean; 
    title: string;
    commentType: string; 
    comments: models.CommentsResponse;    
    onRefresh?: () => void;
}

interface State {
    showModal: boolean; 
    showReportModal: boolean; 
    selectedReportId: number | null;
}

class Comments extends React.Component<Props, State> {  
    public state = {
        showModal: false, 
        showReportModal: false, 
        selectedReportId: null
    };

    private handleTableClick = (e: React.MouseEvent<HTMLTableSectionElement>) => {
        // Target anchor elements explicitly inside our click boundary bubble
        const target = e.target as HTMLElement;
        const anchor = target.closest('a');
        
        if (anchor && anchor.href.includes('/api/ailab/view-report/')) {
            // Prevent the browser from trying to navigate to the new tab natively without headers
            e.preventDefault();
            
            // Extract the target ID identifier number directly from the url path string split
            const urlParts = anchor.href.split('/');
            const reportId = parseInt(urlParts[urlParts.length - 1], 10);
            
            if (!isNaN(reportId)) {
                this.setState({
                    showReportModal: true,
                    selectedReportId: reportId
                });
            }
        }
    };

    public toggleReportModal = () => {
        this.setState({ showReportModal: false, selectedReportId: null });
    };

    public toggleModal = () => {
        this.setState({showModal: !this.state.showModal}); 
    } 

    public render() {
        const { comments, title, commentType, isLoading, onRefresh } = this.props; 
        const { showModal } = this.state; 
        const canEditClaim = userHasPermission("Can Edit Claims Info"); 

        return (
            <>
            <CommentModal
                commentType={ commentType }
                showModal={showModal}
                closeModal={this.toggleModal}
            /> 
            {this.state.showReportModal && this.state.selectedReportId && (
                <AiReportViewerModal 
                    reportId={this.state.selectedReportId} 
                    onClose={this.toggleReportModal} 
                />
            )}
            <Card className="claim-card" style={{height: '100%', display: 'flex', flexDirection: 'column'}}>
                <Card.Title>{title}
                    {isLoading && <span>&nbsp;&nbsp;<Spinner animation="border" role="status" variant="primary" size="sm"/></span>}
                    {canEditClaim && 
                        <SingleActionButton
                            action="Add"
                            title={title}
                            img={addIcon}
                            onClick={this.toggleModal}
                        />
                    }
                    {onRefresh &&
                        <SingleActionButton
                            action="Refresh"
                            title={title}
                            img={refreshIcon}
                            onClick={onRefresh}
                            disabled={isLoading}
                        />
                    }
                </Card.Title>
                <CardBody style={{maxHeight: '400px', overflow: 'auto'}}>
                    {comments.totalCount > 0 && 
                        <Table striped style={{overflowY: "scroll"}}>
                            <thead>
                                <tr>
                                    <th style={{width:100}}>Modified Date</th>
                                    <th style={{width:100}}>Modified By</th>
                                    <th>Comment</th>
                                </tr>
                            </thead>
                            <tbody onClick={this.handleTableClick}>
                                {comments.resourceList.map((comment, i) => (
                                    <tr key={i}>                                    
                                        <td>{dateFormat(comment.modifiedDate, 'mm/dd/yyyy')}</td>
                                        <td>{comment.modifiedBy}</td>
                                        
                                        <td 
                                            style={{ whiteSpace: 'pre-line' }} 
                                            dangerouslySetInnerHTML={{ __html: comment.comment }} 
                                        />
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                        }
                </CardBody>
            </Card>
            </>
        );
    }
}

export default (Comments);